import * as types from '../actionTypes';

const initialState = {
  practiceOrganizationForm: [],
  loading: false,
  error: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_PRACTICE_ORGANIZATION_FORM_REQUEST:
      return {...state, loading: true, error: null};
    case types.FETCH_PRACTICE_ORGANIZATION_FORM_SUCCESS:
      return {...state, loading: false, practiceOrganizationForm: action.practiceOrganizationForm, error: null};
    case types.FETCH_PRACTICE_ORGANIZATION_FORM_FAILURE:
      return {...state, loading: false, error: action.error};
    default:
      return {...state};
  }
};

export default reducer;